import { withLayout } from '@lib/rn-utils';
import styled, { css } from 'styled-components';

const navSize = 60;
export const headerHeight = 56;
export const topOffset = navSize + headerHeight;
export const getContentSize = (stickyHeight: number = 0) =>
  `calc(100vh - ${topOffset + stickyHeight}px)`;
export const drawerScrollHeight = `calc(100vh - ${headerHeight}px)`;

export const virtualStyle: React.CSSProperties = {
  overflowY: 'auto',
  height: drawerScrollHeight,
  contain: 'strict',
};

export const clsPrefix = 'life-id-drawer';

export const modalClasses = {
  title: `${clsPrefix}-title`,
  icon: `${clsPrefix}-icon`,
  clsButton: `${clsPrefix}-close-btn`,
  body: `${clsPrefix}-body`,
  footer: `${clsPrefix}-footer`,
  extra: `${clsPrefix}-extra`,
  contentWrapper: `${clsPrefix}-content-wrapper`,
} as const;

export const DrawerHeader = styled.div`
  min-height: 56px;

  position: sticky;
  top: 0;
  z-index: 99;
  display: flex;
  align-items: center;

  background: ${({ theme }) => theme.color.surface.backgroundDark};

  .${modalClasses.clsButton} {
    margin: 12px;
  }

  .${modalClasses.extra} {
    display: flex;
    align-items: center;
    justify-items: center;
    margin-right: 12px;
  }

  .${modalClasses.icon} {
    margin-right: 12px;
  }

  .${modalClasses.title} {
    flex: 1;
    padding-right: 12px;
    color: ${({ theme }) => theme.color.tint.primaryDark};
    ${({ theme }) => theme.mappedTypography.h5.default};
  }
`;

const DrawerExpandedHeader = styled.div<{ sticky?: boolean }>`
  padding: 12px 24px 24px 24px;
  color: ${({ theme }) => theme.color.tint.primaryDark};
  background: ${({ theme }) => theme.color.surface.backgroundDark};

  ${({ sticky }) =>
    sticky
      ? css`
          position: sticky;
          top: 56px;
          z-index: 99;
        `
      : ''};

  overflow: hidden;
  border-bottom-left-radius: ${({ theme }) => theme.radius.large}px;
  border-bottom-right-radius: ${({ theme }) => theme.radius.large}px;
`;

export const DrawerContent = styled.div`
  border-left: 1px solid ${({ theme }) => theme.color.border.emphasis};
`;

/**
 * Header with onLayout function to measure height for infinite lists.
 */
const HeaderWithLayout = withLayout(DrawerExpandedHeader);

export { HeaderWithLayout as DrawerExpandedHeader };
